export default {
  pt: {
    BANNER_BUTTON: 'Ver detalhes',
    COURSE_RECOMMENDATION: 'Cursos recomendados pela comunidade',
    COURSE_NEW: 'Cursos novos',
    COURSE_WATCH_MORE_2: 'Ver todos',
    COURSE_MEMBERSHIP_TITLE: 'Obtenha acesso total com o Premium',
    COURSE_MEMBERSHIP_SUBTITLE:
      'Junte-se à nossa comunidade Premium e acesse +1000 cursos e +9 carreiras.',
    COURSE_MEMBERSHIP_BUTTON: 'Tenho interesse',
    COURSE_CAREERS_TITLE:
      'Torne-se um <span className="{specialistClassnames}">especialista</span>',
    COURSE_CAREERS_WATCH_MORE: 'Explore mais especializações',
    COURSE_CERTIFICATIONS_TITLE: 'Obter certificação',
    COURSE_CERTIICATIONS_WATCH_MORE: 'Explore mais certificações',
    SHOW_ALL_COURSES: 'Mostrar todos os cursos',
    ALL_COURSES: 'Todos os cursos',
    SEO_RECOMMENDED: 'Cursos recomendados pela comunidade',
    SEO_NEWS: 'Novos Cursos Online',
    SEO_FREE: 'Cursos online grátis',
    SEO_DISCOUNT: 'Cursos em oferta',
    FILTER: 'Filtrar',
    SORT_BY: 'Organizar',
    RESET_FILTERS: 'Limpar',
    RETURN: 'Voltar',
    CLEAN_FILTERS: 'Limpar filtros',
    AD_TITLE1: 'Aproveite o ',
    AD_TITLE2: '% de desconto na sua proxima compra!',
    AD_MIN_AMOUNT: 'Quantidade mínima',
    AD_DESCRIPTION:
      'Seu desconto será aplicado no momento de sua compra. Aplica-se apenas a cursos e certificações.',
    AD_BUTTON: 'Leve-me ao catálogo',
    BECOME_PREMIUM: 'Aproveitar',
    BECOME_PREMIUM_DESCRIPTION: 'Acesse todos esses cursos com descontos',
    SIGNUP_BANNER_TITLE: 'Acesse esses cursos gratuitamente!',
    BANNER_FREE_TITLE: 'Experimente um novo jeito de aprender',
    BANNER_FREE_SUBTITLE:
      'Faça um teste gratuita da assinatura Premium e descubra mais de 800 cursos por um dia inteiro.',
    BANNER_FREE_CTA: 'Experimente de graça hoje',

    EXIT_POPUP_TITLE: 'Opa! Você tem um teste gratuito disponível',
    EXIT_POPUP_SUB_TITLE:
      'Você ainda tem mais cursos para descobrir com nossa assinatura, totalmente gratuitos por 24 horas.',
    EXIT_POPUP_CTA: 'Experimente agora',
    POPUP_MARATHON_TITLE: 'Seja bem-vindo à Maratona de Crehana!',
    POPUP_MARATHON_CTA_LABEL: 'Começar',
    BUY_NOW: 'Comprar agora',
    BUY: 'Comprar',
    LANGUAGE: 'Idioma',
    BACK_TO_TOP: 'Voltar para cima',
    VISUAL_REST_FREE_TITLE: 'Obtenha acesso total com Premium',
    VISUAL_REST_FREE_SUBTITLE:
      'Junte-se à nossa comunidade Premium e acesse +1000 cursos em 16 carreiras.',
    VISUAL_REST_BE_PREMIUM: 'Quero ser Premium',
    VISUAL_REST_PREMIUM_TITLE: 'Prepare sua equipe para os desafios de hoje',
    START: 'Começo',
    RESULTS_EMPTY_SUBTITLE:
      'No entanto, achamos que esses cursos podem interessar a você',
    CATALOG_IMPROVE_SKILLS: 'Melhore outras habilidades',
    CATALOG_COURSE_IN_TITLE: 'Cursos em',
    CATALOG_COURSE_IN_X_TITLE: 'Cursos em {{name}}',
    CATALOG_COURSE_OF_TITLE: 'Cursos de',
    CATALOG_COURSE_OF_X_TITLE: 'Cursos de {{name}}',
    CATALOG_NOT_RESULTS_FOR: 'Não encontramos resultados para {{name}}',
    CATALOG_STUDENTS: 'Alunos',
    CATALOG_CLEAN_FILTERS: 'Apagar filtros',
    CATALOG_APPLIED_FILTERS: 'Filtros aplicados',
    CATALOG_LINK_ONLINE_COURSES: 'Cursos online',
    CATALOG_LINK_NEW_COURSES: 'Cursos novos',
    CATALOG_LINK_OFFERT_COURSES: 'Cursos em oferta',
    CATALOG_LINK_FREE_COURSES: 'Cursos grátis',
    CATALOG_CATEGORIES: 'Categorias',
    CATALOG_SOFTWARE: 'Programas',
    CATALOG_NIVEL: 'Níveis',
    CATALOG_SHOW_MORE: 'Ver mais',
    CATALOG_SHOW_LESS: 'Ver menos',
    CATALOG_FILTER_RESULTS: 'Resultados do filtro',
    CATALOG_APPLY_FILTERS: 'Aplicar filtros',
    CATALOG_ORDER_BY: 'Organize por',
    CATALOG_PREMIUM_VISUAL_REST_MESSAGE:
      'Desenvolva o talento de sua organização com programas de skilling.',
    CATALOG_BE_PREMIUM: 'Seja Premium',
    CATALOG_FILTER_DURATION: 'Duração',
    COURSE_TAG_FREE: 'Curso grátis',

    GIFT_TO_FRIEND_BTN: 'Presente para um amigo',
    TOTAL_LABEL: 'Resultado',
    TOTAL_LABEL_2: 'Resultados',
    FREE_LABEL: 'Grátis',

    /**
     *  se usa tempralmente labels de organizar por:
     * hasta que backend haga las traducciones
     *  */
    Recomendados: 'Recomendado',
    Ofertas: 'Ofertas',
    Nuevos: 'Novo',
    'Cursos Gratis': 'Cursos grátis',
    CATALOG_ACADEMIES_SECTION_TITLE:
      'Academias relacionadas con {{categoryName}}',
    SUBSCRIBE_FREE: 'Inscreva-se gratuitamente!',

    PREVIEW_TRIAL_START_BUTTON: 'Experimente o curso gratuito',
  },
};
